import { arcgisURL } from "@/config/api-config";

const processedFactories = {
  title: "Processing Factories",
  url: arcgisURL + "Biomass_Factories_GeoJSON/FeatureServer",
  opacity: 0.8,
  renderer: {
    type: "unique-value",
    field: "source",
    defaultSymbol: {
      type: "simple-marker",
      style: "triangle",
      color: "#006400",
      size: 12,
      opacity: 0.8,
      outline: {
        color: "white",
        width: 0.5,
      },
    },
    uniqueValueInfos: [
      {
        value: "Biochar Partners",
        symbol: {
          type: "simple-marker",
          style: "triangle",
          color: "#228B22",
          size: 12,
          opacity: 0.8,
          outline: {
            color: "white",
            width: 0.5,
          },
        },
      },
      {
        value: "GRID",
        symbol: {
          type: "simple-marker",
          style: "triangle",
          color: "#32CD32",
          size: 12,
          opacity: 0.8,
          outline: {
            color: "white",
            width: 0.5,
          },
        },
      },
      {
        value: "Google",
        symbol: {
          type: "simple-marker",
          style: "triangle",
          color: "#32CD32",
          size: 12,
          opacity: 0.8,
          outline: {
            color: "white",
            width: 0.5,
          },
        },
      },
    ],
  },
  popupTemplate: {
    title: "{fctry_st_n}",
    content: [
      {
        type: "fields",
        fieldInfos: [
          {
            fieldName: "wardname",
            label: "Ward",
          },
          {
            fieldName: "lganame",
            label: "LGA",
          },
          {
            fieldName: "statename",
            label: "State",
          },
          {
            fieldName: "fctry_st_n",
            label: "Factory Name",
          },
          {
            fieldName: "source",
            label: "Source",
          },
          {
            fieldName: "biomass_type",
            label: "Biomass Type",
          },
          {
            fieldName: "biomass_waste",
            label: "Biomass Waste",
          },
        ],
      },
    ],
  },
  visible: false,
//   legendEnabled: false,
};

export default processedFactories;